import { pfLanguages } from '../pf'

export const pjLanguages = pfLanguages
